import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

//const baseURL = "http://localhost:3044";
const baseURL = "https://atci.abcuniversity.accenture.com/abc-university-apis";

export const UsersSlice = createSlice({
  name: "UserList",
  initialState: {
    usersData: [],
    newUser: "",
    updateStatus: null,
  },
  reducers: {
    setError: (state) => {
      state.error = true;
      state.updateStatus = "error";
    },
    setUpdateStatus: (state, { payload }) => {
      state.updateStatus = payload; // can be "success" or "error"
    },
    resetUpdateStatus: (state) => {
      state.updateStatus = null; // reset the status to close the modal
    },
    setUsersData: (state, { payload }) => {
      state.error = false;
      state.usersData = payload;
    },
    setNewUser: (state, { payload }) => {
      state.error = false;
      state.newUser = payload;
    },
    removeItem: (state, { payload }) => {
      state.error = false;
      state.usersData = state.usersData.filter(
        (item) => item.EnterpriseID !== payload
      );
    },
  },
});

export const {
  setError,
  setUsersData,
  setNewUser,
  removeItem,
  setUpdateStatus,
  resetUpdateStatus,
} = UsersSlice.actions;
export default UsersSlice.reducer;

export function getUsers() {
  return (dispatch) => {
    axios
      .get(`${baseURL}/getUsers`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
        params: {
          timestamp: new Date().getTime(), // Append timestamp here
        },
      })
      .then((res) => {
        dispatch(setUsersData(res.data.results));
        console.log("res from get api", res.data.results);
        console.log("get users success!!!");
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}

export function addUser(username, purpose, market, du, isAdmin) {
  return (dispatch, getState) => {
    const { usersData } = getState().users;
    const isDuplicate = Array.isArray(usersData)
      ? usersData.some(
          (user) => user.EnterpriseID?.toLowerCase() === username.toLowerCase()
        )
      : [];
    if (isDuplicate) {
      dispatch(setUpdateStatus("duplicate"));
      return;
    }
    axios
      .post(
        `${baseURL}/adduser`,
        { username, purpose, market, du, isAdmin },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
          },
          params: {
            timestamp: new Date().getTime(), // Append timestamp here
          },
        }
      )
      .then((res) => {
        dispatch(setUpdateStatus("success"));
        dispatch(setNewUser(username));
        dispatch(getUsers());
        console.log("res from post api", res.data);
      })
      .catch((err) => {
        dispatch(setUpdateStatus("error"));
        console.error("error is", err);
      });
  };
}

export function updateUser(username, isAdmin, isActive) {
  return (dispatch) => {
    axios
      .post(
        `${baseURL}/updateuser`,
        { username, isAdmin, isActive },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
          },
          params: {
            timestamp: new Date().getTime(), // Append timestamp here
          },
        }
      )
      .then((res) => {
        dispatch(setUpdateStatus("update"));
        dispatch(getUsers());
        console.log("res from post api", res.data);
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}

export function deleteEnterpriseID(entId) {
  return (dispatch) => {
    axios
      .delete(`${baseURL}/deleteUser/${entId}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
        params: {
          timestamp: new Date().getTime(), // Append timestamp here
        },
      })
      .then((res) => {
        console.log("delete successfull!", entId);
        dispatch(removeItem(entId));
        // setDeleteSuccess(!deleteSuccess);
        dispatch(getUsers());
      })
      .catch((err) => {
        console.error("ERRORRR is", err);
      });
  };
}
